'use client';

import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import Link from 'next/link';
import React, { useMemo } from 'react';
import AutoScroll from 'embla-carousel-auto-scroll';
import { Carousel, CarouselContent, CarouselItem } from '@/shadcn/components/Carousel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_LOGOS = [{
  id: 'Amy Northard, CPA',
  description: 'Amy Northard, Certified Public Accountants',
  image: '/img/pages/home/amy-northard-cpa.webp'
}, {
  id: 'Quakka Hub',
  description: 'Business consulting and services.',
  url: 'https://www.quokkahub.com/',
  image: '/img/pages/home/quokka-hub.webp'
}, {
  id: 'CAT Athleticism Testing',
  description: 'Unlocking athletic potential using the CAT Score.',
  image: '/img/pages/home/cat-athletic-testing.webp'
}, {
  id: 'Rank Brain Media',
  description: 'Websites, SEO, and fully-managed digital marketing.',
  image: '/img/pages/home/rankbrain-media.webp'
}, {
  id: 'Before Tax',
  description: 'Free small business tax savings tools and calculators.',
  image: '/img/pages/home/before-tax.webp'
}];

const BrandCarousel = _ref => {
  let {
    heading = '',
    className = '',
    items = DEFAULT_LOGOS
  } = _ref;
  return /*#__PURE__*/_jsxs("section", {
    className: clsx('py-32', className),
    children: [heading && /*#__PURE__*/_jsx("div", {
      className: "container flex flex-col  mr-auto ml-auto items-center text-center",
      children: /*#__PURE__*/_jsx("h3", {
        className: "my-6 text-pretty text-2xl font-bold lg:text-4xl",
        children: heading
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "pt-10 md:pt-16 lg:pt-20",
      children: /*#__PURE__*/_jsxs("div", {
        className: "relative mx-auto flex items-center justify-center lg:max-w-5xl",
        children: [/*#__PURE__*/_jsx(Carousel, {
          opts: {
            loop: true
          },
          plugins: [AutoScroll({
            playOnInit: true
          })],
          children: /*#__PURE__*/_jsx(CarouselContent, {
            className: "ml-0",
            children: items.map(logo => /*#__PURE__*/_jsx(CarouselItem, {
              className: "basis-1/2 pl-0 md:basis-1/3",
              children: /*#__PURE__*/_jsx("div", {
                className: "mx-10 flex shrink-0 items-center justify-center",
                children: /*#__PURE__*/_jsx(BrandItem, _objectSpread({}, logo))
              })
            }, logo.id))
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-background to-transparent"
        }), /*#__PURE__*/_jsx("div", {
          className: "absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background to-transparent"
        })]
      })
    })]
  });
};

const BrandItem = _ref2 => {
  let {
    image,
    description,
    url
  } = _ref2;
  const imgAttrs = useMemo(() => ({
    src: image,
    alt: description,
    className: 'block h-10 object-contain w-auto',
    loading: 'lazy'
  }), [image, description]);

  if (url) {
    return /*#__PURE__*/_jsx(Link, {
      href: url,
      title: description,
      target: "_blank",
      rel: "noopener",
      children: /*#__PURE__*/_jsx("img", _objectSpread({}, imgAttrs))
    });
  }

  return /*#__PURE__*/_jsx("img", _objectSpread({}, imgAttrs));
};

export default BrandCarousel;